
/**
 * 메시지 상태 정보
 */
export type ChatRoomListResponsePageAllOfThreeContentItemLastMessageStatus = {
  isRead?: boolean;
};
